import { render, staticRenderFns } from "./PhotographyImages.vue?vue&type=template&id=3c5673ba&scoped=true&"
import script from "./PhotographyImages.vue?vue&type=script&lang=js&"
export * from "./PhotographyImages.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyImages.vue?vue&type=style&index=0&id=3c5673ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5673ba",
  null
  
)

export default component.exports